// flow weak

/* eslint no-console:0 */
/* eslint consistent-return:0 */

/*
  imports
 */
import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  getSessionData, postSessionData
}                           from '../../services/API';
import {
  fetchMockstatsTableData
}                           from '../../services/fetchMocks';
import * as ReduxTypes      from '../types';

/*
  constants
 */
const REQUEST_SESSION_DATA   = 'REQUEST_SESSION_DATA';
const RECEIVED_SESSION_DATA  = 'RECEIVED_SESSION_DATA';
const ERROR_SESSION_DATA     = 'ERROR_SESSION_DATA';


let session = {
  isFetching: false,
  // headers:     [],
  data:   null,
  // requested_venue_id: 0,
  // venue_id: -1,
  time:       null
};

/*
  reducer
 */
  let initialStateCopy = {};
  for (var property in appConfig.sessions.data) {
      // console.log(property);
      // console.log(appConfig.sessions.data.hasOwnProperty(property));
      // console.log(Object.getOwnPropertyNames(appConfig.sessions.data));
    if (appConfig.sessions.data.hasOwnProperty(property) && property != "API") {
        initialStateCopy[property] = Object.assign({}, session);
        initialStateCopy[`reset::${property}`] = Object.assign({}, session);
    }
  } 
  const initialState = initialStateCopy;
  // const initialState = session;

export default function session(state = initialState, action) {
  console.log(initialState);
  console.log("Session plan call - API");
  console.log(appConfig.sessions.data);
  console.log(action);
  let data = initialState;
  // return state
  switch (action.type) {
  case 'CHANGE_LOCATION_FOR_SESSION_PLAN':
    console.log("SH - REQUEST_LOCATION_CHANGE");
    console.log(state);
    data[action.name].requested_venue_id = action.selectedLocation;
    return Object.assign({}, state, data);
  case 'REFRESH_SESSION_DATA':
    console.log("SH- REFRESH_SESSION_DATA");
    fetchSessionDataIfNeeded(action.venue_id,action.name);
    return state;        
  case 'REQUEST_SESSION_DATA':
    console.log("SH - REQUEST_SESSION_DATA data");
    console.log(state);
    console.log(action);
    console.log(data);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    return Object.assign({}, state, data);
  case 'RECEIVED_SESSION_DATA':
    console.log("SH - RECEIVED_SESSION_DATA data");
    console.log(action);
    console.log(state);
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    // data[action.name].headers = action.headers;
    data[action.name].data = action.data;
    // data[action.name].venue_id = action.venue_id;
    let newstate = Object.assign({}, state, data);
    console.log(newstate);
    return newstate;
  case 'ERROR_SESSION_DATA':
    data[action.name].isFetching = action.isFetching;
    data[action.name].time = action.time;
    data[action.name].headers = [];
    data[action.name].data = [[]];
    //To avoid api loop
    //Stop at first api error.
    data[action.name].venue_id = state[action.name].requested_venue_id;    
    return Object.assign({}, state, data);
  default:
    return state;
  }
}


/*
  action creators
 */
// export function fetchSessionDataIfNeeded(id=0,name) {
export function fetchSessionDataIfNeeded(name, params) {
    console.log("SP ifNeeded");
  return (
    dispatch, 
    getState
  ) => {
    // if (shouldFetchSessionData(getState(),name)) {
    if (shouldFetchSessionData(getState(), name) || name.split("::")[0] == "reset") {
      // return dispatch(fetchSessionData(id,name));
      return dispatch(fetchSessionData(name, params));
    }
  };
}
export function throwSessionDataHandler(name, payload) {
    console.log("SP if throw handler");
  return (
    dispatch, 
    getState
) => dispatch(throwSessionData(name, payload));
}

function requestSessionData(name,time = moment().format()) {
  return {
    type:       REQUEST_SESSION_DATA,
    isFetching: true,
    time,name
  };
}
function receivedSessionData(data,name, time = moment().format()) {
    console.log("receivedSessionData");
    console.log(data);
  return {
    type:       RECEIVED_SESSION_DATA,
    isFetching: false,
    // headers:     [...data.headers],
    data:   data,
    // venue_id:   data.venue_id,
    time,name
  };
}
function errorSessionData(error,name, time = moment().format()) {
  return {
    type:       ERROR_SESSION_DATA,
    isFetching: false,
    error,
    time,name
  };
}
function fetchSessionData(name, params) {
    // console.log(id);
    console.log(name);
    console.log("SH fetchSessionData");
  return dispatch => {
    dispatch(requestSessionData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedSessionData(null,name.split("::")[1] ));
    } else if (name == "find" && params!= null){
        var query_params = "?"
        Object.keys(params).map(function(key, index) {
            query_params = query_params + `${key}=${params[key]}&`;
        });

      getSessionData(name, query_params)
        .then(
          data => dispatch(receivedSessionData(data,name))
        )
        .catch(
          error => dispatch(errorSessionData(error,name))
        );      
    }
    else{
        //Redux data clearing request.
        dispatch(receivedSessionData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}
function throwSessionData(name, payload) {
    // console.log(id);
    console.log(name);
    console.log("SH throwSessionData");
  return dispatch => {
    dispatch(requestSessionData(name));
    if(name.split("::")[0] == "reset"){
        dispatch(receivedSessionData(null,name.split("::")[1] ));
    } else if (name != ""){
        postSessionData(name, payload)
          .then(
            data => dispatch(receivedSessionData(data,name))
          )
          .catch(
            error => dispatch(errorSessionData(error,name))
          );
    } else{
        //Redux data clearing request.
        dispatch(receivedSessionData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
      }

  };
}

function shouldFetchSessionData(state,name) {
    console.log(state);
  const spStore = state.session[name];
  if (spStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/session.js